import React from "react";

const StatusPill: React.FC<{ active: boolean; className?: string }> = ({
  active,
  className,
}) => (
  <div
    className={`${className || ""} items-center px-3 py-1.5 rounded-full text-xs font-medium ${
      active
        ? "bg-green-50 text-green-700 border border-green-200"
        : "bg-red-50 text-gray-700 border border-gray-200"
    }`}
  >
    <div className="relative flex items-center">
      <span
        className={`w-2.5 h-2.5 rounded-full mr-2 ${
          active ? "bg-green-500" : "bg-red-400"
        }`}
      />
      {active ? (
        <span className="absolute w-2.5 h-2.5 rounded-full bg-green-500 animate-ping opacity-75" />
      ) : (
        <span className="absolute w-2.5 h-2.5 rounded-full bg-red-500 animate-ping opacity-75" />
      )}
    </div>
    {active ? "Active" : "Closed"}
  </div>
);
export default StatusPill;
